module.exports = __webpack_public_path__ + "img/other.ba1a50d9.png";